import React from "react";

import { LightCompanyBlock } from "@app/components/footer/common/company/light-company";
import { useIsAccountAvailable } from "@app/helpers/whitelabels/hooks";

import { PickerLanguage } from "../../picker-language";
import { AccountItem } from "../common/account-item";
import { FooterBase } from "../common/footer-base";
import { FooterItem } from "../common/footer-item";
import { PickerCurrency } from "../common/picker-currency";
import { FooterBaseSection } from "../footer-base-section";
import { FooterMainSection } from "../footer-main-section";

export const FunnelFooter: React.FC = () => {
  const is_account_available = useIsAccountAvailable();

  return (
    <footer
      id="footer" // Used as target for `SkipLink` in `renderHeader()` in `controllers/results`
      tabIndex={-1} // Makes it focusable when we navigate to it by clicking a skip link
    >
      <FooterMainSection className="sm:hidden">
        {!!is_account_available && (
          <FooterItem>
            <AccountItem />
          </FooterItem>
        )}
        <FooterItem>
          <PickerLanguage size="md" />
        </FooterItem>
        <FooterItem>
          <PickerCurrency />
        </FooterItem>
        <FooterItem>
          <LightCompanyBlock />
        </FooterItem>
      </FooterMainSection>
      <FooterBaseSection>
        <FooterBase variant="default" />
      </FooterBaseSection>
    </footer>
  );
};
